import Button, { ButtonStyle } from './Button';

export default Button;
export { ButtonStyle };
